const getFormattedText = (string) => {
  switch (true) {
    case string["E"]: {
      return `<i>${string.__text}</i>`;
    }
    case string["U"]: {
      return `<sup>${string.__text}</sup>`;
    }
    case string["B"]: {
      return `<b>${string.__text}</b>`;
    }
    default: {
      return string.__text;
    }
  }
};

export const parseAndRenderText = (string) => {
  if (!string) return null;
  switch (true) {
    case typeof string === "object": {
      return getFormattedText(string);
    }
    default: {
      return string;
    }
  }
};

export const getTitle = function (data) {
  if (!data.i18n) return data.name;
  const translatedItem = data.i18n[this.language || "en"];
  return translatedItem ? translatedItem : data.name;
};

/* Updates a counter of number of times widget has been used, and sets value in localStorage. */
export const updateNumberOfTimesUsed = function () {
  const numberOfTimesUsed = parseInt(localStorage.getItem("numberOfTimesUsed"));
  const hasSignedUp = localStorage.getItem("signedUp") === "true";

  if (!hasSignedUp) {
    localStorage.setItem("numberOfTimesUsed", numberOfTimesUsed + 1 || 1);
  }
};
